// extracted by mini-css-extract-plugin
export default {"fr-view":"BackButton_fr-view__Ik5e9"};